import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Clock } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { TIPS_COPY } from '../../seo/articles';

/** Card used on the tips hub, related lists and guide "go deeper" blocks. */
export const ArticleCard = ({ article, lang, compact = false }) => {
  const copy = TIPS_COPY[lang];
  return (
    <Card className="bg-lux-panel/90 border-white/10 hover:border-lux-gold/40 transition-[border-color] duration-200 overflow-hidden group h-full" data-testid={`article-card-${article.key}`}>
      <Link to={article.path} className="flex flex-col h-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--lux-gold)] rounded-lg" aria-label={article.title}>
        <div className={`relative overflow-hidden bg-black/40 ${compact ? 'aspect-[3/1.6]' : 'aspect-[3/2]'}`}>
          <img src={article.cover} alt={article.imageAlt} width="1200" height="800" loading="lazy" className="w-full h-full object-cover opacity-90 group-hover:opacity-100 transition-opacity duration-200" />
          <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-black/70 backdrop-blur-sm text-[10px] uppercase tracking-wider text-[var(--lux-amber)] font-semibold">{copy.byAxis} {article.axis} {'\u00b7'} {article.axisName}</span>
        </div>
        <CardContent className={`flex flex-col flex-1 ${compact ? 'p-4 gap-2' : 'p-5 gap-3'}`}>
          <h3 className={`font-semibold text-white leading-snug ${compact ? 'text-sm' : 'text-lg'}`}>{article.title}</h3>
          {!compact && <p className="text-sm text-white/55 leading-relaxed flex-1">{article.excerpt}</p>}
          <div className="flex items-center justify-between text-xs text-white/40 pt-1 mt-auto">
            <span className="inline-flex items-center gap-1.5"><Clock className="w-3.5 h-3.5 text-[var(--lux-gold)]" /> {article.minutes} {copy.readingTime}</span>
            <span className="inline-flex items-center gap-1 text-[var(--lux-gold)] group-hover:text-[var(--lux-amber)] transition-colors duration-200">{copy.readMore} <ArrowRight className="w-3.5 h-3.5" /></span>
          </div>
        </CardContent>
      </Link>
    </Card>
  );
};
